import i18n from '../../i18n';
import { showAppToast } from './showAppToast';

export function notifyTenantSessionRemoved(tenantName?: string | null): void {
  showAppToast({
    variant: 'error',
    title: tenantName?.trim() || i18n.t('tenant_dropdown_header'),
    message: i18n.t('tenant_session_removed_invalid_message'),
  });
}
